import { Typography, TypographyProps } from "@mui/material";
import React from "react";

export const LongTextField = (props: TypographyProps) => {
    return (
        <Typography {...props} sx={{ wordWrap: "break-word" }}>
            {props.children}
        </Typography>
    );
};
